export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  category: string;
  image: string;
  tags: string[];
  views: string;
  readTime: string;
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '宫崎骏：动画世界的造梦大师',
    excerpt: '从《龙猫》到《你想活出怎样的人生》，宫崎骏用画笔构建了一个又一个令人沉醉的幻想世界，他的作品不仅是动画，更是一种文化现象。',
    content: '<p>在日本动画的星空中，宫崎骏无疑是最耀眼的那颗星。从早期作品到最新力作，他的每一部电影都像一扇通往奇幻世界的大门。</p><h2>从东映到吉卜力</h2><p>宫崎骏1941年出生于东京，1963年加入东映动画，开始了他的动画生涯。在经历了多年的磨练后，1985年他与高畑勋共同创立了吉卜力工作室，这个决定改变了世界动画的格局。</p><h2>代表作回顾</h2><p>《风之谷》（1984年）奠定了宫崎骏的独特风格——关注自然与人类的和谐共生。此后的《天空之城》《龙猫》《魔女宅急便》等作品，逐渐建立起他温暖治愈的叙事风格。</p><p>1997年的《幽灵公主》和2001年的《千与千寻》达到了艺术与商业的双重巅峰。后者不仅成为日本影史票房冠军，还斩获了奥斯卡最佳动画长片奖。</p><h2>永不停止的创作</h2><p>即便多次宣布退休，宫崎骏仍然无法放下画笔。他的最新作品《你想活出怎样的人生》再次证明了这位动画大师的创作力依然旺盛。</p><p>宫崎骏的作品之所以能够跨越国界打动全球观众，在于他作品中永恒的主题：成长、勇气、爱与和平。他用动画创造了一个个美好的世界，也让我们重新审视自己的生活。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-08-10',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Hayao%20Miyazaki%20animation%20studio%20aesthetic%2C%20Ghibli%20style%20workspace%2C%20warm%20golden%20lighting%2C%20cream%20background%2C%20creative%20artistic%20atmosphere%2C%20sketches%20and%20drawings%2C%20clean%20composition&width=600&height=300&seq=article-a001&orientation=landscape',
    tags: ['宫崎骏', '吉卜力', '动画电影'],
    views: '12.8万',
    readTime: '8分钟',
  },
  {
    id: 'a002',
    title: '韩国电影崛起：从新浪潮到全球现象',
    excerpt: '从《寄生虫》斩获奥斯卡到《鱿鱼游戏》席卷全球，韩国影视产业用二十年时间完成了从追赶者到引领者的华丽转身。',
    content: '<p>如果说二十一世纪前二十年全球电影产业最大的惊喜是什么，韩国电影的崛起绝对是当之无愧的答案。从1999年的《生死谍变》到2019年的《寄生虫》，韩国电影完成了一次惊人的蜕变。</p><h2>新浪潮的开端</h2><p>1990年代末，随着韩国电影审查制度的废除和配额制度的建立，一批年轻导演开始崭露头角。朴赞郁、奉俊昊、金基德、李沧东等人用极具个人风格的影像语言，重新定义了韩国电影。</p><h2>类型片的成熟</h2><p>韩国电影最令人称道的是其类型片的成熟度。无论是《老男孩》的复仇叙事，《杀人回忆》的犯罪悬疑，还是《釜山行》的丧尸灾难，韩国电影人总能在类型框架中注入深刻的社会思考。</p><h2>全球化之路</h2><p>2019年《寄生虫》在戛纳摘得金棕榈，随后横扫奥斯卡四项大奖，成为首部获得最佳影片的非英语电影。这不仅是对奉俊昊个人的肯定，更是对韩国电影工业整体实力的认可。</p><p>随着Netflix等流媒体平台的全球扩张，《鱿鱼游戏》《黑暗荣耀》等韩剧也创造了现象级的全球热潮，韩国内容产业正在书写新的传奇。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-08-08',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cinema%20modern%20film%20industry%20aesthetic%2C%20elegant%20movie%20poster%20wall%2C%20warm%20dramatic%20lighting%2C%20cream%20background%2C%20artistic%20cinematic%20visual%2C%20clean%20composition&width=600&height=300&seq=article-a002&orientation=landscape',
    tags: ['韩国电影', '寄生虫', '奉俊昊'],
    views: '9.6万',
    readTime: '7分钟',
  },
  {
    id: 'a003',
    title: '纪录片的力量：用镜头记录真实亚洲',
    excerpt: '纪录片是时代的眼睛，亚洲纪录片创作者们用镜头捕捉着这片大陆上最真实、最动人的故事。',
    content: '<p>在娱乐至上的时代，纪录片始终坚守着真实的力量。亚洲的纪录片创作者们，用他们的镜头记录下了这片古老大陆上的变迁与坚守。</p><h2>中国纪录片的新浪潮</h2><p>从《舌尖上的中国》到《河西走廊》，从《我在故宫修文物》到《风味人间》，中国纪录片在近年来完成了从电视专题片到电影级制作的跨越。这些作品不仅在国内引发热议，也获得了国际观众的认可。</p><h2>日本纪录片的细腻视角</h2><p>日本纪录片以其细腻的观察和深刻的人文关怀著称。是枝裕和早期的纪录片作品，以及NHK出品的大量社会纪实，都展现了日本纪录片人对生活本质的敏锐洞察。</p><h2>纪录片的未来</h2><p>随着流媒体平台的兴起，纪录片获得了前所未有的传播渠道。无论是BBC的自然纪录片系列，还是Netflix的真实犯罪纪录片，都证明了这一类型的巨大潜力。</p><p>亚洲纪录片人正在用他们的方式，讲述属于亚洲的故事。这些镜头下的真实，比任何虚构都更加震撼人心。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-08-05',
    category: 'jilupian',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20filmmaking%20Asian%20nature%20and%20culture%20aesthetic%2C%20professional%20camera%20on%20tripod%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20cinematic%20visual%2C%20clean%20composition&width=600&height=300&seq=article-a003&orientation=landscape',
    tags: ['纪录片', '真实故事', '亚洲文化'],
    views: '7.2万',
    readTime: '6分钟',
  },
  {
    id: 'a004',
    title: '中国科幻电影的崛起之路',
    excerpt: '从《流浪地球》开启中国科幻电影元年，到《三体》引发全球期待，中国科幻正在书写属于自己的星辰大海。',
    content: '<p>2019年，《流浪地球》的上映被媒体称为"中国科幻电影元年"。四年后，《流浪地球2》以更成熟的工业水准证明，中国科幻电影已经站稳了脚跟。</p><h2>从零到一的突破</h2><p>在《流浪地球》之前，中国电影工业几乎没有真正的硬科幻作品。郭帆导演和他的团队从零开始，搭建了完整的科幻电影制作体系，包括物理特效、数字特效、概念设计等各个环节。</p><h2>中国式科幻叙事</h2><p>与好莱坞科幻片强调个人英雄主义不同，中国科幻电影倾向于展现集体主义和人类命运共同体的价值观。《流浪地球》中"带着地球去流浪"的设定，本身就充满了东方浪漫主义色彩。</p><h2>未来的星辰大海</h2><p>随着《三体》影视化改编的推进，以及更多科幻IP的开发，中国科幻电影正在进入一个快速发展的黄金时期。技术进步和人才积累将为这个类型带来更多可能性。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-08-01',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20film%20futuristic%20aesthetic%2C%20space%20and%20stars%2C%20warm%20dramatic%20lighting%2C%20cream%20background%2C%20epic%20cinematic%20visual%2C%20clean%20composition&width=600&height=300&seq=article-a004&orientation=landscape',
    tags: ['科幻', '流浪地球', '中国电影'],
    views: '15.3万',
    readTime: '8分钟',
  },
  {
    id: 'a005',
    title: '经典日剧推荐：平成时代的影像记忆',
    excerpt: '从《东京爱情故事》到《白色巨塔》，那些陪伴我们成长的日剧，承载着无数人的青春记忆。',
    content: '<p>日剧以其精炼的篇幅、深刻的社会洞察和独特的审美风格，在亚洲电视剧领域占有不可替代的地位。</p><h2>纯爱经典</h2><p>《东京爱情故事》《悠长假期》《美丽人生》——这些九十年代的经典纯爱剧，定义了整整一代人对爱情的理解。木村拓哉、松隆子、中山美穗等演员成为那个时代的符号。</p><h2>社会派日剧</h2><p>《白色巨塔》深刻揭露医疗体制的黑暗面，《半泽直树》以倍返し的痛快反击让观众大呼过瘾，《legal high》用幽默的方式探讨法律与正义。这些作品不仅娱乐性强，更引发社会思考。</p><h2>新时代日剧</h2><p>Netflix等流媒体平台的进入为日剧带来了新的可能。《全裸导演》《弥留之国的爱丽丝》等作品以更大胆的叙事和更高的制作水准，让日剧走向了全球观众。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-07-28',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Japanese%20TV%20drama%20nostalgic%20aesthetic%2C%20Tokyo%20cityscape%20evening%2C%20warm%20retro%20lighting%2C%20cream%20background%2C%201990s%20Japanese%20visual%20style%2C%20clean%20composition&width=600&height=300&seq=article-a005&orientation=landscape',
    tags: ['日剧', '经典', '东京爱情故事'],
    views: '8.9万',
    readTime: '6分钟',
  },
  {
    id: 'a006',
    title: '亚洲动画的黄金时代：中日韩三国演义',
    excerpt: '日本动画的深厚积淀、中国动画的快速崛起、韩国动画的独特风格，亚洲动画产业正在迎来前所未有的繁荣时期。',
    content: '<p>动画是亚洲文化输出的重要载体。近年来，中日韩三国的动画产业各有建树，共同推动了亚洲动画的繁荣发展。</p><h2>日本：动画王国的坚守与创新</h2><p>日本动画产业拥有近百年的历史积淀。从手冢治虫开创的电视动画时代，到宫崎骏、新海诚引领的剧场版动画热潮，日本动画始终保持强大的创造力和全球影响力。</p><h2>中国：国产动画的春天</h2><p>从《大圣归来》到《哪吒之魔童降世》，从《白蛇：缘起》到《长安三万里》，中国动画电影在技术和叙事上都实现了质的飞跃。同时，《时光代理人》《罗小黑战记》等动画剧集也获得了广泛好评。</p><h2>韩国：风格化的新势力</h2><p>韩国动画虽然产量不如中日两国，但凭借独特的艺术风格和精良的制作水准，在国际市场上越来越受关注。《外貌至上主义》等Webtoon改编作品展现了韩国动画的潜力。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-07-25',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Asian%20animation%20art%20studio%20aesthetic%2C%20colorful%20illustration%20boards%2C%20warm%20creative%20workspace%20lighting%2C%20cream%20background%2C%20anime%20production%20visual%2C%20clean%20composition&width=600&height=300&seq=article-a006&orientation=landscape',
    tags: ['动画', '中日韩', '动漫产业'],
    views: '11.2万',
    readTime: '7分钟',
  },
  {
    id: 'a007',
    title: '印度电影不止宝莱坞：多元化的南亚电影版图',
    excerpt: '除了一言不合就跳舞的宝莱坞商业片，印度还有泰米尔语电影、马拉雅拉姆语电影等丰富多元的电影生态。',
    content: '<p>提到印度电影，很多人首先想到的是宝莱坞的歌舞片。但实际上，印度拥有极其多元和丰富的电影生态。</p><h2>宝莱坞之外</h2><p>印度按语言分为多个电影产业中心：以印地语为主的宝莱坞（孟买）、泰米尔语电影（科莱坞）、泰卢固语电影（托莱坞）、马拉雅拉姆语电影（莫莱坞）等。每个电影产业都有自己独特的风格和观众群。</p><h2>现实主义浪潮</h2><p>近年来，印度现实主义电影在国际上获得越来越多的认可。《调音师》《塔巴德》《村子里有情况》等作品以精湛的叙事和深刻的社会洞察，刷新了人们对印度电影的认知。</p><h2>全球化的印度电影</h2><p>《RRR》获得奥斯卡最佳原创歌曲奖，《大象之歌》入围多个国际电影节，印度电影正在以更加多元的面貌走向世界舞台。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-07-20',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Indian%20cinema%20diverse%20film%20industry%20aesthetic%2C%20colorful%20movie%20posters%2C%20warm%20vibrant%20lighting%2C%20cream%20background%2C%20Bollywood%20and%20regional%20cinema%2C%20clean%20composition&width=600&height=300&seq=article-a007&orientation=landscape',
    tags: ['印度电影', '宝莱坞', '南亚电影'],
    views: '5.6万',
    readTime: '6分钟',
  },
  {
    id: 'a008',
    title: '短视频时代的短片创作新浪潮',
    excerpt: '在短视频席卷全球的时代，短片创作迎来了前所未有的发展机遇，越来越多的创作者用短小精悍的影像表达自我。',
    content: '<p>短片创作正在经历一场前所未有的变革。从电影节到短视频平台，短片的形式和传播方式都在发生深刻的变化。</p><h2>短片的前世今生</h2><p>短片一直是电影人起步的重要形式。许多大师级导演都是从短片开始他们的创作生涯。戛纳、柏林等国际电影节都设有短片竞赛单元，为新人导演提供展示才华的舞台。</p><h2>短视频平台的崛起</h2><p>TikTok、YouTube Shorts、Instagram Reels等平台的兴起，让短片创作真正走进了大众生活。创意、技术与故事的结合，催生了大量令人惊艳的微型影像作品。</p><h2>亚洲短片的独特魅力</h2><p>亚洲短片创作者以其独特的文化视角和审美表达，在国际短片领域备受瞩目。无论是日本导演的极简美学，还是中国新锐导演的社会观察，都在短片这一载体中找到了完美的表达方式。</p>',
    author: '亚洲精品视频编辑部',
    date: '2025-07-15',
    category: 'duanpian',
    image: 'https://readdy.ai/api/search-image?query=Short%20film%20creation%20modern%20filmmaking%20aesthetic%2C%20smartphone%20and%20camera%20setup%2C%20warm%20creative%20lighting%2C%20cream%20background%2C%20indie%20film%20visual%2C%20clean%20composition&width=600&height=300&seq=article-a008&orientation=landscape',
    tags: ['短片', '短视频', '创作'],
    views: '6.8万',
    readTime: '5分钟',
  },
];